import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectUserRbacPermissions } from 'core/userContext';
import { HeaderGridRow } from 'ui/indexPages/tables/grid';
import { Column } from 'ui/indexPages/tables/header/constants';
import { useSortingContext } from 'utils/contexts/sorting';
import { PROJECT_PERMISSIONS } from 'utils/permissions';
import { TableHeaderButton } from '../../campaignIndex/components/TableHeaderButton';
import { SNIPPET_TABLE_COLUMNS } from '../constants';
import { getSnippetHeaderGrid } from '../utils';

type Props = {
  columns?: Column[];
};

export const SnippetTableHeader = ({ columns = SNIPPET_TABLE_COLUMNS }: Props) => {
  const { sortBy, sortDirection, setSortBy, setSortDirection } = useSortingContext();
  const permissions = useSelector(selectUserRbacPermissions);
  const canManageSnippets = useMemo(
    () => permissions.includes(PROJECT_PERMISSIONS.ManageSnippets),
    [permissions],
  );

  return (
    <HeaderGridRow gridLayout={getSnippetHeaderGrid(canManageSnippets)}>
      {columns.map((column) => (
        <TableHeaderButton
          key={column.id}
          sortDirection={sortDirection}
          onSortByChange={setSortBy}
          onSortDirectionChange={setSortDirection}
          isActiveSortColumn={column.id === sortBy}
          isSortable={!!column.isSortable}
          {...column}
        />
      ))}
    </HeaderGridRow>
  );
};
